<template>
<div class="nrs-footer">

    <!-- Copyright -->
    <div class="nrs-footer-copyright">
        Copyright &copy;
        {{copyrightyear}}
        NetRoadshow, Inc. All rights reserved.
    </div>
</div>
</template>

<script>
export default {
  name: 'FooterSimple',
  data() {
    const currentyear = new Date().getFullYear();
    return {
      copyrightyear: currentyear,
    };
  },
};
</script>

<style lang="less" scoped>
*, :before, :after {
    box-sizing: border-box;
}

.nrs-footer {
    min-height: 50px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 499;
    height: auto;
    border-top: 1px solid #ddd;
    background-color: #f9f9f9;
}

.nrs-footer-copyright {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 10px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    font-size: 12px;
    color: #686868;
    font-weight: 500;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 26px;
}
</style>
